export enum FillDatesTypeEnum {
    Unset = 0,
    CloseDatesForBooking = 1,
    SetupPricePolicy = 2
}
